import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { axiosRelayInstance } from "../../../../axios.js";
import { POST_BOT_CHAT, GET_PAYMENT_HISTORY_LIST, POST_VOICE_PARSE } from "../../../../Urls.js";

const initialState = {
  chatRespose: { data: "", loader: false, successMessage: "" },
  paymentHistoriesData: { data: [], loading: false },
  commonBotActivate:false
};

export const voiceParseAPI = createAsyncThunk(
  "app/get/voiceParseAPI",
  async (data) => {
    const response = await axiosRelayInstance.post(POST_VOICE_PARSE, { ...data });
    return response;
  }
);

export const getChatResponse = createAsyncThunk(
  "app/get/getChatResponse",
  async (data) => {
    const response = await axiosRelayInstance.post(POST_BOT_CHAT, { ...data });
    return response;
  }
);
export const getPaymentHistory = createAsyncThunk(
  "app/get/chat/paymentHistory",
  async (payload) => {
    const response = await axios.post(GET_PAYMENT_HISTORY_LIST, { ...payload });
    return response;
  }
);

export const chatBotSlice = createSlice({
  name: "app/messageListSlice",
  initialState,
  reducers: {
    selectedMesage: (state, action) => {
      state.selectedMesage = action?.payload;
    },
    clearResponse: (state) => {
      state.chatRespose.data = "";
    },
    clearHistory: (state) => {
      state.paymentHistoriesData.data = [];
    },
    setActivatebot: (state, action) => {
      state.commonBotActivate = action?.payload;
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(getChatResponse.pending, (state) => {
        state.chatRespose.loader = true;
      })
      .addCase(getChatResponse.fulfilled, (state, action) => {
        state.chatRespose.loader = false;
        state.chatRespose.data = action?.payload?.data;
        state.chatRespose.successMessage = "Message created successfully!";
      })
      .addCase(getChatResponse.rejected, (state) => {
        state.chatRespose.loader = false;
        state.chatRespose.data = {};
        state.chatRespose.successMessage = "Failed to create message!";
      })
      .addCase(getPaymentHistory.pending, (state) => {
        state.paymentHistoriesData.loading = true;
      })
      .addCase(getPaymentHistory.fulfilled, (state, action) => {
        state.paymentHistoriesData.loading = false;
        state.paymentHistoriesData.data = action?.payload?.data?.data;
      })
      .addCase(getPaymentHistory.rejected, (state) => {
        state.paymentHistoriesData.loading = false;
        state.paymentHistoriesData.data = [];
      });
  },
});

export const { clearResponse, clearHistory,setActivatebot } = chatBotSlice.actions;

export default chatBotSlice.reducer;
